
import React, { Component } from 'react'
import { MuiGrid, MuiDialog, MuiDialogTitle, MuiTypography, MuiButton, MuiInfoIcon, MuiDialogActions, MuiDivider } from '../../../../ui/MaterialUIComponents'
import { TeacherAndTAsContainer } from '../dialog/teacherAndTAs'
import { RequiredSharedRoomContainer } from './requiredSharedRoom'
import { dialogComponentName } from './DialogComponentUtil'
import { MultiPeriodRulesContainer } from './multiPeriodRules';
import { FixedTeachersAndTAsContainer } from './fixedTeachersAndTAs'
import PrefferedPeriodComtainer from '../dialog/preferredPeriod/PreferredPeriodContainer'
import { JointClassContainer } from './'
import { UnjoinClassesContainer } from './unjoinClasses'
import lodashUtil from 'lodash'
import theme from '../../../../../assests/theme'

class CommonDialogComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
        this.rulesDataObj = {};
        this.components = {
            0: TeacherAndTAsContainer,
            1: FixedTeachersAndTAsContainer,
            2: MultiPeriodRulesContainer,
            3: PrefferedPeriodComtainer,
            4: RequiredSharedRoomContainer,
            5: JointClassContainer
        };
    }
    componentWillMount() {
        const i18n = this.props.i18n
        let rulesTab = this.props.rulesTab
        let jointClassIndex = lodashUtil.findIndex(rulesTab, ["label", i18n.rules.menuJointClassConstraints])
        if (jointClassIndex === -1) {
            this.components[5] = UnjoinClassesContainer
        }
    }

    getComponent = () => {
        let Comp = this.components[this.props.index];
        return (
            <Comp

                {...this.props}
            />
        )
    }

    render() {
        return (
            <MuiGrid>
                <MuiDialog
                    open={this.props.dialogOpen}

                >

                    <MuiDialogTitle style={{ background: theme.palette.grey.dark }} >
                        <MuiGrid container>
                            <MuiGrid item xs container alignItems="center" justify="center" >
                                <MuiTypography style={{ fontFamily: "Arial", fontSize: '15px', color: "white" }}>
                                    {this.props.label}
                                </MuiTypography>
                            </MuiGrid>

                            <MuiGrid item container alignItems="center" justify="center" xs={1} >
                                <MuiButton >
                                    <MuiInfoIcon style={{ color: "white" }} size="small" />
                                </MuiButton>
                            </MuiGrid>
                        </MuiGrid>
                    </MuiDialogTitle>
                    <MuiGrid container style={{ padding: "20px" }}>
                        {this.getComponent()}
                    </MuiGrid>
                </MuiDialog>
            </MuiGrid>
        )
    }
}

export default CommonDialogComponent
